import {
  FaUserGraduate,
  FaBriefcase,
  FaProjectDiagram,
  FaLaptopCode,
  FaGlobe,
  FaBullhorn,
  FaShoppingCart,
  FaChalkboardTeacher,
  FaHandshake,
  FaClipboardList,
} from "react-icons/fa";

const services = [
  {
    title: "Placement Training & Assistance",
    slug: "placement-training-assistance",
    icon: <FaUserGraduate />,
    description:
      "Prepare for recruitment with resume support, screening tests, technical and HR interviews, communication skills, and interview readiness.",
    gradient: "from-emerald-500 to-lime-500",
    showOnHome: true,
  },

  {
    title: "Internships & Certifications",
    slug: "internships-certifications",
    icon: <FaBriefcase />,
    description:
      "Gain practical experience through internships, real-time project exposure, and professional certification programs.",
    gradient: "from-blue-500 to-cyan-500",
    showOnHome: true,
  },

  {
    title: "Academic & Final-Year Projects",
    slug: "academic-final-year-projects",
    icon: <FaProjectDiagram />,
    description:
      "Get practical guidance for academic and final-year projects using relevant technologies and project-based learning.",
    gradient: "from-indigo-500 to-purple-500",
    showOnHome: true,
  },

  {
    title: "IT Training & Certification",
    slug: "it-training-certification",
    icon: <FaLaptopCode />,
    description:
      "Build technical skills through specialized training in software development, data analytics, and professional IT programs.",
    gradient: "from-pink-500 to-rose-500",
    showOnHome: true,
  },

  {
    title: "Website Design & Development",
    slug: "website-design-development",
    icon: <FaGlobe />,
    description:
      "Design and develop modern websites and full-stack solutions for businesses, institutions, and professional organizations.",
    gradient: "from-sky-400 to-blue-600",
    showOnHome: true,
  },

  {
    title: "Digital Marketing",
    slug: "digital-marketing",
    icon: <FaBullhorn />,
    description:
      "Build digital visibility through SEO, social media, content marketing, analytics, and growth-focused strategies.",
    gradient: "from-yellow-400 to-orange-500",
    showOnHome: true,
  },

  {
    title: "E-Commerce Development",
    slug: "e-commerce-development",
    icon: <FaShoppingCart />,
    description:
      "Build scalable e-commerce websites with modern interfaces, product management, and secure payment integration.",
    gradient: "from-teal-400 to-cyan-600",
    showOnHome: false,
  },

  {
    title: "Campus Recruitment Training",
    slug: "campus-recruitment-training",
    icon: <FaChalkboardTeacher />,
    description:
      "Prepare students for campus recruitment through aptitude training, technical preparation, communication practice, and mock interviews.",
    gradient: "from-green-400 to-lime-500",
    showOnHome: false,
  },

  {
    title: "Corporate Collaboration & Industry Connect",
    slug: "corporate-collaboration-industry-connect",
    icon: <FaHandshake />,
    description:
      "Support industry collaboration through internships, live projects, recruitment initiatives, and professional engagement.",
    gradient: "from-fuchsia-500 to-purple-700",
    showOnHome: false,
  },

  {
    title: "Career Assessment & Guidance",
    slug: "career-assessment-guidance",
    icon: <FaClipboardList />,
    description:
      "Assess skills, explore career directions, and build practical development plans with structured career guidance.",
    gradient: "from-rose-500 to-red-600",
    showOnHome: false,
  },
];

export default services;